@if(selectAll) {
<div class="w-full text-end pb-2 text-sm font-bold text-blue-600">
  <button (click)="checkAll()">
    {{ !allSelected ? 'Seleccionar todos' : 'Borrar selección ' }}
  </button>
</div>
} @if(lateral) {
<div class="grid grid-cols-12 gap-4">
  @for (item of options; track $index) {
  <div class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12">
    <c-multi-item
      [data]="item"
      [itemProperty]="itemProperty"
      [subData]="subOpt"
      [subItemProperty]="subItemProperty"
      (selectedData)="getData($event, $index)"
      [parentOnly]="parentOnly"
      [itemDescriptionProp]="itemDescriptionProp"
      [subDescriptionProp]="subDescriptionProp"
      [identificadorS]="identificadorS"
      [identificadorI]="identificadorI"
    />
  </div>

  }
</div>
} @else { @for (item of options; track $index) {
<c-multi-item
  [data]="item"
  [itemProperty]="itemProperty"
  [subData]="subOpt"
  [subItemProperty]="subItemProperty"
  (selectedData)="getData($event, $index)"
  [parentOnly]="parentOnly"
  [itemDescriptionProp]="itemDescriptionProp"
  [subDescriptionProp]="subDescriptionProp"
  [identificadorS]="identificadorS"
  [identificadorI]="identificadorI"
/>
} }
